export const styles = {
  container: 'w-full',
  stepContainer: 'relative grow lg:grow-0 lg:shrink lg:pb-[1rem]',
  stepLine:
    'absolute bottom-0 left-0 h-[0.2rem] w-full flex-1 rounded-sm bg-neutral40',
  stepLineFilled: 'h-full rounded-sm bg-accentSecondary40',
  stepLabel: 'shrink break-words',
  labelContainer: 'shrink items-center gap-sm lg:items-start',
};
